<template>
  <div class="products-individuals-wrapper">
    <IndividualsHeader :el="'zn'" />
    <div class="text-group">
      <h3 class="text-zn">{{ $t('products-zn-1') }}</h3>
      <p>{{ $t('products-zn-2') }}</p>
      <p>{{ $t('products-zn-3') }}</p>
    </div>
    <Gallery :gallery="gallery" />
    <div class="content-row">
      <Dropdown
        :id="'znDropdownOne'"
        :color="color"
        :title="$t('products-zn-dd1-1')"
        :content="dropdownOne"
        :open="true"
      />
    </div>
    <div class="content-row" id="alloysElement">
      <Dropdown
        :id="'znDropdownTwo'"
        :color="color"
        :title="$t('products-zn-dd2-1')"
        :content="dropdownTwo"
        :open="true"
      />
    </div>
    <!-- <div class="content-row">
      <Dropdown
        :id="'znDropdownThree'"
        :color="color"
        :title="$t('products-zn-dd3-1')"
        :content="dropdownThree"
        :open="true"
      />
    </div>-->
    <div class="content-row">
      <Dropdown
        :id="'znDropdownFour'"
        :color="color"
        :title="$t('products-zn-dd4-1')"
        :content="dropdownFour"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Files :color="color" :files="files" />
    </div>
    <InterestingFacts :title="$t('products-zn-if-title')" :facts="facts" :color="'#67AAAE'" />
  </div>
</template>

<script>
import IndividualsHeader from "./shared/IndividualsHeader";
import InterestingFacts from "./shared/InterestingFacts";
import Dropdown from "./shared/Dropdown";
import Gallery from "./shared/Gallery";
import Files from "./shared/Files";

export default {
  components: {
    IndividualsHeader,
    InterestingFacts,
    Dropdown,
    Gallery,
    Files
  },
  props: ["color"],
  data() {
    return {
      gallery: [
        {
          type: "image",
          url: require("../../../assets/img/products/zn/zinc_gallery_1.jpg")
        },
        {
          type: "video",
          url: require("../../../assets/video/products/zinc_gallery_2.mp4")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/zn/zinc_gallery_3.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/zn/zinc_gallery_4.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/zn/zinc_gallery_5.jpg")
        }
      ],
      files: {
        bg: [
          "Брошура КЦМ Цинк.pdf",
          "Цинк-Информационен лист за безопасност.pdf"
        ],
        en: [
          "Brochure KCM Zinc.pdf",
          "Zinc metal SDS.pdf",
          "CGG SDS.pdf",
          "Zinc Sulphate SDS.pdf"
        ]
      }
    };
  },
  computed: {
    dropdownOne() {
      return {
        table: [
          [this.$t("brand"), "Z1/SHG"],
          [this.$t("elements"), "%"],
          [{ el: "Zn" }, "99.995 min."],
          [{ el: "Pb" }, "0.003 max."],
          [{ el: "Cd" }, "0.003 max."],
          [{ el: "Fe" }, "0.002 max."],
          [{ el: "Sn" }, "0.001 max."],
          [{ el: "Cu" }, "0.001 max."],
          [{ el: "Al" }, "0.001 max."]
        ],
        columns: {
          titles: [this.$t("products-zn-dd1-2")],
          left: [
            {
              img: require("../../../assets/img/products/zn/dd1_scheme.svg")
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "24 +/- 2.5 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "415-425 mm",
                w: "207-215 mm",
                h: "50-60 mm"
              }
            },
            {
              spec: {
                title: this.$t("products-dd-2"),
                mass: "900-1050 kg",
                left: this.$t("products-dd-4"),
                right: this.$t("products-dd-5"),
                l: "860 mm",
                w: "430 mm",
                h: "550-600 mm"
              }
            },
            {
              title: this.$t("products-zn-dd1-3"),
              texts: [this.$t("products-zn-dd1-4")]
            },
            {
              title: this.$t("products-zn-dd1-5"),
              texts: [this.$t("products-zn-dd1-6")]
            }
          ]
        }
      };
    },
    dropdownTwo() {
      return {
        table: [
          [{ text: this.$t("products-zn-dd2-2"), colspan: 2 }],
          [this.$t("brand"), "CGG"],
          [this.$t("elements"), "%"],
          [{ el: "Al" }, "0.2-1.00"],
          [{ el: "Pb" }, "0.003 max."],
          [{ el: "Fe" }, "0.003 max."],
          [{ el: "Cd" }, "0.003 max."],
          [{ el: "Cu" }, "0.001 max."],
          [{ el: "Sn" }, "0.001 max."],
          [{ el: "Zn" }, this.$t("products-dd-6")]
        ],
        columns: {
          titles: [this.$t("products-zn-dd2-3"), this.$t("products-zn-dd2-4")],
          left: [
            {
              img: require("../../../assets/img/products/zn/dd2_scheme.svg")
            },
            {
              title: this.$t("products-zn-dd2-5"),
              texts: [
                this.$t("products-zn-dd2-6"),
                this.$t("products-zn-dd2-7")
              ]
            },
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "990 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "1270 mm",
                w: "504 mm",
                h: "300 mm"
              }
            }
            // {
            //   title: this.$t('products-zn-dd2-8'),
            //   texts: [this.$t('products-zn-dd2-9')]
            // },
            // {
            //   title: this.$t('products-zn-dd2-10'),
            //   texts: [this.$t('products-zn-dd2-11')]
            // }
          ],
          right: [
            {
              img: require("../../../assets/img/products/zn/dd2_2_scheme.svg")
            },
            {
              title: this.$t("products-zn-dd2-12"),
              texts: [
                this.$t("products-zn-dd2-13"),
                this.$t("products-zn-dd2-14")
              ]
            },
            {
              spec: {
                title: this.$t("products-dd-1"),
                mass: "1990 kg",
                left: this.$t("products-dd-3"),
                right: this.$t("products-dd-5"),
                l: "2150 mm",
                w: "490 mm",
                h: "385 mm"
              }
            }
            // {
            //   title: this.$t('products-zn-dd2-8'),
            //   texts: [this.$t('products-zn-dd2-9')]
            // },
            // {
            //   title: this.$t('products-zn-dd2-10'),
            //   texts: [this.$t('products-zn-dd2-11')]
            // }
          ]
        }
      };
    },
    // dropdownThree: {
    //   table: [
    //     [{ text: this.$t("products-zn-dd3-2"), colspan: 3 }],
    //     [this.$t("brand"), "ПЦ3/PC3", this.$t("products-zn-dd3-3")],
    //     [this.$t("elements"), "%", "%"],
    //     [{ el: "Zn" }, "92.0 min.", "98.5 min."],
    //     [{ el: "Fe" }, "0.05 max.", "0.0035 max."],
    //     [{ el: "Cd" }, "0.01 max.", "0.0005 max."],
    //     [{ el: "Cu" }, "0.005 max.", "0.004 max."],
    //     [{ el: "Pb" }, "0.05 max.", "0.002 max."],
    //     [{ el: "Sn" }, "0.005 max.", "0.003 max."],
    //     [{ el: "As" }, "0.005 max.", "0.005 max."],
    //     [{ el: "Sb" }, "0.005 max.", "0.005 max."],
    //     [this.$t("products-zn-dd3-4"), "0.3 max.", "0.3 max."],
    //     [{ el: "Cl" }, "0.2 max.", "0.2 max."],
    //     [this.$t("products-zn-dd3-5"), "1.5 max.", "1.5 max."]
    //   ]
    // },
    dropdownFour() {
      return {
        table: [
          [
            this.$t("products-zn-dd4-2"),
            { text: this.$t("products-zn-dd4-3"), colspan: 2 },
            this.$t("products-zn-dd4-4"),
            this.$t("products-zn-dd4-5")
          ],
          [
            this.$t("products-zn-dd4-6-0"),
            this.$t("products-zn-dd4-6"),
            this.$t("products-zn-dd4-7"),
            "",
            ""
          ],
          [this.$t("products-zn-dd4-8"), "21.6", "20.0", "37.0", "39.5"],
          [this.$t("products-zn-dd4-9"), "0.3", "0.4", "0.04", "0.007"],
          [this.$t("products-zn-dd4-10"), "0.2", "0.3", "0.05", "0.0025"],
          [this.$t("products-zn-dd4-11"), "0.1", "0.5", "0.02", "0.0035"],
          [this.$t("products-zn-dd4-12"), "-", "-", "0.03", "0.01"],
          [this.$t("products-zn-dd4-13"), "-", "-", "-", "-"],
          [{ text: this.$t("products-zn-dd4-14"), colspan: 5 }]
        ],
        columns: {
          titles: [
            this.$t("products-zn-dd4-15"),
            this.$t("products-zn-dd4-16")
          ],
          left: [
            {
              title: this.$t("products-zn-dd4-17"),
              texts: [this.$t("products-zn-dd4-18")]
            }
          ],
          right: [
            {
              title: this.$t("products-zn-dd4-19"),
              texts: [this.$t("products-zn-dd4-20")]
            }
          ]
        }
      };
    },
    facts() {
      return [
        {
          img: require("../../../assets/img/products/zn/if_1.png"),
          text: this.$t("products-zn-if-1")
        },
        {
          img: require("../../../assets/img/products/zn/if_2.png"),
          text: this.$t("products-zn-if-2")
        },
        {
          img: require("../../../assets/img/products/zn/if_3.png"),
          text: this.$t("products-zn-if-3")
        },
        {
          img: require("../../../assets/img/products/zn/if_4.png"),
          text: this.$t("products-zn-if-4")
        },
        {
          img: require("../../../assets/img/products/zn/if_5.png"),
          text: this.$t("products-zn-if-5")
        },
        {
          img: require("../../../assets/img/products/zn/if_6.png"),
          text: this.$t("products-zn-if-6")
        },
        {
          img: require("../../../assets/img/products/zn/if_7.png"),
          text: this.$t("products-zn-if-7")
        },
        {
          img: require("../../../assets/img/products/zn/if_8.png"),
          text: this.$t("products-zn-if-8")
        },
        {
          img: require("../../../assets/img/products/zn/if_9.png"),
          text: this.$t("products-zn-if-9")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.products-individuals-wrapper {
  padding-bottom: 50px;
  .text-group {
    margin: 0 auto;
    padding-top: 40px;
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
  .content-row {
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
}

@media screen and (max-width: 1600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1280px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
    .content-row {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
    .content-row {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
  }
}
</style>

